"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('transition', {
    attrs: {
      "name": _vm.disableTransitions ? '' : 'el-zoom-in-center'
    }
  }, [_c('span', {
    staticClass: "el-tag",
    "class": [_vm.type ? 'el-tag--' + _vm.type : '', _vm.tagSize && "el-tag--" + _vm.tagSize, {
      'is-hit': _vm.hit
    }],
    style: {
      backgroundColor: _vm.color
    },
    attrs: {}
  }, [_vm._t("default", null, {}), _vm._v(" "), _vm.closable ? _c('i', {
    staticClass: "el-tag__close el-icon-close",
    attrs: {},
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.handleClose($event);
      }
    }
  }) : _vm._e()], 2)]);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'ElTag',
  props: {
    text: String,
    closable: Boolean,
    type: String,
    hit: Boolean,
    disableTransitions: Boolean,
    color: String,

    /** 扩展 */
    size: {
      type: String,
      "default": 'small'
    }
    /** ** */

  },
  methods: {
    handleClose: function handleClose(event) {
      this.$emit('close', event);
    }
  },
  computed: {
    tagSize: function tagSize() {
      return this.size || (this.$ELEMENT || {}).size;
    }
  }
};
exports["default"] = _default;